import Model from "./base/model";

class QuotationStatus extends Model{
  resourceName() {
    return "quotation_status";
  }

  fields() {
    return {
      name: "",
      description: ""
    };
  }
}

export default new QuotationStatus();
